import { Modal } from '@hungryroot/ramen';

type ServingSizeWarningModalProps = {
  testid: string;
  heading: string;
  onActionClick: () => void;
  onDismiss: () => void;
};

export const PLAN_SERVING_SIZE_WARNING_MODAL_LOCAL_STORAGE_PROP =
  'recipe-outside-serving-size-seen';

export function ServingSizeWarningModal(props: ServingSizeWarningModalProps) {
  const { testid, heading, onActionClick, onDismiss } = props;
  return (
    <Modal
      ariaLabel="Recipe outside plan serving size modal"
      confirmButtonText="Got it"
      testid={testid}
      isOpen={true}
      showXButton={false}
      heading={heading}
      body="FYI: This recipe has different servings than your plan size."
      onActionClick={() => {
        localStorage.setItem(
          PLAN_SERVING_SIZE_WARNING_MODAL_LOCAL_STORAGE_PROP,
          'true'
        );
        onActionClick();
      }}
      onDismiss={() => {
        localStorage.setItem(
          PLAN_SERVING_SIZE_WARNING_MODAL_LOCAL_STORAGE_PROP,
          'true'
        );
        onDismiss();
      }}
    />
  );
}
